<template>
  <div    v-loading='btnLoading' class="fillcontain">
    <LinkTitle></LinkTitle>
    <div id="div_print" v-show="isPrint">
      <h2></h2>
      <h2 class="printTitle">{{ stockOutBillObj.store_name }}</h2>
      <h2 class="printTitle">发货单NO{{ stockOutBillObj.orderId }}</h2>
      <div class="printHead">
        <div>购货客户编号:{{ stockOutBillObj.buy_id }}</div>
        <div>购货客户名称:{{ stockOutBillObj.buy_name }}</div>
        <div>发货时间:{{ getTime(stockOutBillObj.sendTime) }}</div>
        <div>业务员:{{ stockOutBillObj.sell_name }}</div>
        <div>仓库:{{ stockOutBillObj.p_address }}</div>
        <div>摘要:无</div>
        <div>收货地址:{{ stockOutBillObj.address }}</div>
      </div>
      <table
        width="80%"
        border="0"
        class="table"
        cellspacing="0"
        cellpadding="0"
      >
        <tr>
          <td width="105">存货编号</td>
          <td width="181">存货名称</td>
          <td width="112">辅单位</td>
          <td width="105">辅数量</td>
          <td width="181">主单位</td>
          <td width="112">数量</td>
          <td width="112">金额</td>
        </tr>
        <tr v-for="(item, index) in productData" :key="index">
          <td width="105">{{ item.pid }}</td>
          <td width="181">{{ item.p_name }}</td>
          <td width="112">{{ item.buyUnit }}</td>
          <td width="105">{{ item.number }}</td>
          <td width="181">{{ item.unit }}</td>
          <td width="112">{{ item.totalWeight }}</td>
          <td width="112">{{ item.money }}</td>
        </tr>
        <tr>
          <td width="105" colspan="3">总计</td>
          <td width="105"></td>
          <td width="181"></td>
          <td width="112"></td>
          <td width="112">{{ stockOutBillObj.totalMoney }}</td>
        </tr>
      </table>
      <div class="printMoney">
        金额（大写）: {{ stockOutBillObj.upperMoney }}
      </div>
      <div class="printMsg">
        <div>制单人:</div>
        <div>审核人:</div>
        <div>库管:</div>
        <div>送货人:</div>
        <div>签收人:</div>
        <div></div>
      </div>
      <div class="printRemark">
        注:
        一式六联:一联存银(白)、二联财务(粉)、三联发票(绿)、四联客户(蓝)、五联提货(黄)、六联门卫(米白)、
      </div>
    </div>
    <div class="table_container">
      <PageSearchTitle title="我的订单" :hideCart="true" />
      <div class="order">
        <div class="orderListTitle">
          <template>
            <el-tabs v-model="activeName" @tab-click="handlePaneClick">
              <!-- <el-tabs v-model="activeName" type='border-card' @tab-click="handlePaneClick"> -->
              <el-tab-pane name="allList">
                <span slot="label" class="orderTabsTitleText">全部</span>
              </el-tab-pane>
              <el-tab-pane name="payingList">
                <span slot="label" class="orderTabsTitleText">待付款</span>
              </el-tab-pane>
              <el-tab-pane name="waitingShipmentsList">
                <span slot="label" class="orderTabsTitleText">待发货</span>
              </el-tab-pane>
              <el-tab-pane name="waitingTakeDeliveryList">
                <span slot="label" class="orderTabsTitleText">待收货</span>
              </el-tab-pane>
              <el-tab-pane name="waitingCommentList">
                <span slot="label" class="orderTabsTitleText">待评价</span>
              </el-tab-pane>
              <el-tab-pane name="fillingList">
                <span slot="label" class="orderTabsTitleText">补款</span>
              </el-tab-pane>
              <el-tab-pane name="refundList">
                <span slot="label" class="orderTabsTitleText">退款</span>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>

      <div class="orderTitle orderTitleBgc">
        <div class="orderTitleText first">宝贝</div>
        <div class="orderTitleText">单价</div>
        <div class="orderTitleText">数量</div>
        <div class="orderTitleText">商品操作</div>
        <div class="orderTitleText">实付款</div>
        <div class="orderTitleText">交易状态</div>
        <div class="orderTitleText">交易操作</div>
      </div>

      <div class="table_container_header">
        <div class="left"></div>
        <div class="right flexVCenterHright">
          <div class="paginationBox">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pagination.currentPage"
              :page-sizes="pagination.sizes"
              :page-size="pagination.size"
              :hide-on-single-page="true"
              prev-text="上一页"
              next-text="下一页"
              layout=" prev, next"
              :total="pagination.count"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div
        v-loading.lock="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255)"
        class="gooodsList"
      >
        <div
          v-cloak
          v-if="DirectionalContractTableData.length == 0"
          class="empty-list"
        >
          <i class="el-icon-tickets"></i>
          <span class="empty-list-text">暂无订单</span>
        </div>

        <div
          class="orderItem"
          v-for="(item, index) in DirectionalContractTableData"
          :key="'index' + index"
        >
          <div class="goodsTitle orderTitle">
            <div class="orderTitleText first listItem">
              <span class="gooodsListTilecreatTime">{{
                item.createTime | formateDate
              }}</span>
              订单号:{{ item.order_id }}
              <span></span>
            </div>
            <div class="orderTitleText">{{ item.store_name }}</div>
            <div class="orderTitleText"></div>
            <div class="orderTitleText">联系卖家</div>
            <div class="orderTitleText"></div>
            <div class="orderTitleText"></div>
            <div class="orderTitleText"></div>
            <div class="orderTitleText"></div>
          </div>

          <!-- accountPeriod: 0
balance: 0
breed: "黑猪"
buyUnit: "片"
createTime: 1570780153353
grade: 1
id: "77b06e48f909401e94b9bcc02e98fc1e"
imgurl: "group1/M00/00/08/wKjKBF2Cyq-EEaWkAAAAAI6TFV0005.jpg"
number: 1
orderId: "4e02fffa0ce14460b9d0778d0bbe755e"
p_id: "cfe584ef043c4f3382fd01812a35b62e"
p_name: "资源小店白猪110"
prepayment: 0
price: 0.01
totalMoney: 0.01
totalWeight: 1
trackingNo: null
type: 3
          unit: "kg"-->
          <div
            v-for="(productItem, productIndex) in item.products"
            :key="'productIndex' + productIndex"
            class="productsList"
          >
            <div class="productsItems orderTitle">
              <div class="orderTitleText first">
                <div class="orderDescBox">
                  <div class="orderDescBoxLeft">
                    <img
                      class="goodsItemImg"
                      @click="() => checkImgAtTable(productItem)"
                      :src="getImageUrl(productItem.imgurl)"
                      :data-src="getImageUrl(productItem.imgurl)"
                      alt
                    />
                  </div>
                  <div class="orderDescBoxRight">
                    <div
                      @click="() => checkImgAtTable(productItem)"
                      class="orderDescBoxRightPname textHover"
                    >
                      {{ productItem.p_name }}
                    </div>
                    <div>{{ productItem.breed }}</div>
                  </div>
                </div>
              </div>
              <div class="orderTitleText flexVCenter">
                <div class="productItemPrice">
                  &yen;{{ `${productItem.price}/${productItem.unit}` }}
                </div>
              </div>
              <div class="orderTitleText flexVCenter">
                {{
                  productItem.unit &&
                  productItem.unit.toLowerCase() == "kg" &&
                  productItem.buyUnit &&
                  productItem.buyUnit.toLowerCase() != "kg"
                    ? productItem.totalWeight + "kg" + " "
                    : ""
                }}{{ productItem.number + productItem.buyUnit }}
              </div>
              <div class="orderTitleText flexVCenter">
                <div v-if="productIndex == 0">
                  <i class="el-icon-chat-dot-square"></i>
                </div>
              </div>
              <div class="orderTitleText flexVCenter">
                <div class="productItemTotalMoney">
                  <!-- <span v-if='productIndex==0'>&yen;{{item.fm_status==1?item.prepayment:item.totalMoney}}</span> -->
                  <span v-if="productIndex == 0"
                    >&yen;{{ renderItemTotalMoney(item) }}</span
                  >
                </div>
              </div>
              <div class="orderTitleText flexVCenter">
                <span v-if="productIndex == 0">{{
                  formatteStatus(item.o_status, item.fm_status)
                }}</span>
              </div>
              <div class="orderTitleText flexVCenter">
                <!-- <div>



                  <el-button
                    type="primary"
                    size="small"
                    @click="()=>toPay(item)"
                    v-if="((item.o_status==1)||(item.o_status==13))&&(productIndex==0)"
                  >立即付款</el-button>



                </div>-->
                <div class="buttonBox">
                  <div
                    v-for="(buttonItem, buttonIndex) in buttonsArr"
                    :key="buttonIndex + 'buttonsArr'"
                  >
                    <span
                      :class="[
                        'buttonText',
                        'textHover',
                        buttonItem.class ? buttonItem.class : '',
                      ]"
                      v-if="
                        buttonItem.o_status.indexOf(item.o_status) > -1 &&
                        (buttonItem.type
                          ? buttonItem.type.toString().indexOf(item.type) > -1
                          : true) &&
                        productIndex == 0
                      "
                      @click="() => buttonClick(buttonItem.fn, item)"
                      >{{ buttonItem.label }}</span
                    >
                  </div>
                  <!-- <el-button
                    type="text"
                    size="small"
                    @click="()=>toPay(item)"
                    v-if="((item.o_status==1)||(item.o_status==13))&&(productIndex==0)"
                  >立即付款</el-button>-->

                  <!-- {{renderText()}} -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- <iframe :src="formUrl" width="100%" height="100%"></iframe> -->

      <div class="Pagination" v-show="pagination.count">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.currentPage"
          :page-sizes="pagination.sizes"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.count"
        ></el-pagination>
      </div>
      <el-dialog
        title="商品图"
        class="dialog-img-detail"
        :visible.sync="ImgAtTable.dialogShow"
      >
        <div>
          <img class="bigHtImg" :src="ImgAtTable.src" alt />
        </div>
      </el-dialog>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  queryManagerOrderListUrl,
  getImageUrl,
  queryOrderListUrl,
  getOutBillUrl,
  confirmReceiveOrderUrl,
  transBill,
  baseUrl,
  transBilPc 
} from "@/api/api";

import { formateDate } from "@/config/mUtils";
import PageSearchTitle from "@/components/components/PageSearchTitle";
export default {
  data() {
    return {
      count: 0,
      tableData: [],
      currentPage: 1,
      dialogAuditVisible: false,
      tableSelectedItem: [], //
      contractStatus: "0",
      contractList: [],
      DirectionalContractTableData: [],
      currentCompanyBId: "",
      currentContractId: "",
      currentStatus: "",
      formInlineStatus: {
        status: 3,
        type: 1,
      },
      loading: false,
      detailLoading: false,
      pagination: {
        sizes: [1, 5, 15, 50, 100],
        count: 0,
        size: 15,
        currentPage: 1,
      },
      ImgAtTable: {
        src: "",
        dialogShow: false,
      },
      ImgAtForm: {
        src: "",
        dialogShow: false,
      },
      activeName: "allList",
      index: 0,
      buttonsArr: [
        // type订单类型，1供需订单，2普通商品订单，3拍卖订单 4优选订单,
        //6全品类订单，7赶集订单（每个白条不同价格）,9预付款充值订单，10店铺余额充值订单；
        // {o_status:'1,2,3,4,9,12,13',label:'联系买家',fn:'contactCustomer'},

        {
          o_status: "1",
          label: "立即付款",
          class: "ensureGetGoods",
          productIndex: "0",
          fn: "toPay",
        },
        {
          o_status: "3",
          label: "确认收货",
          class: "ensureGetGoods",
          fn: "haveGetGoods",
        },
        {
          o_status: "4",
          label: "电子回单",
          class: "getPdfBtn",
          fn: "downloaindPdf",
        },
        {
          o_status: "5",
          label: "电子回单",
          class: "getPdfBtn",
          fn: "downloaindPdf",
        },
      ],
      currentOrderInfo: null,
      stockOutBillObj: {
        id: "",
        orderId: "", //发货单，订单编号，唯一，8位【Order.order_id】
        store_name: "", // 卖家店铺名【Order.store_name】
        buy_id: "", // 客户编号【Order.buy_id】
        buy_name: "", // 客户名称【Order.buy_name】
        sendTime: "", // 发货时间：年-月-日 时-分【Order.sendTime】
        sell_name: "", // 业务员，商家昵称【Order.sell_name】
        p_address: "", // 仓库地址【Order.p_address】
        address: "", // 收货地址，可空【Order.address】
        totalMoney: "", //所有商品结算总totalMoney；（全款）【Order.totalMoney】
        upperMoney: "", //大写的总金额
      },
      productData: [],
      isPrint: false,
      formUrl: "",
      btnLoading:false
    };
  },
  components: {
    PageSearchTitle,
  },
  computed: {
    ...mapState(["userInfo"]),
    getOrderStatus() {
      switch (this.index) {
        case 0:
          return "";
        case 1:
          return "1";
        case 2:
          return "2";
        case 3:
          return "3";
        case 4:
          return "4";
        case 5:
          return "12,13";
        case 6:
          return "9,10,11,14,15";
      }
    },
  },
  created() {
    this.getImageUrl = getImageUrl;
  },
  mounted() {
    //审批合同请求列表
    this.initOrderList(this.formInlineStatus.status);

    //  let serverUrl = 'https://meat1.chinausmeat.com/generic/web/viewer.html'
    //  let pdfUrl = 'https://meat1.chinausmeat.com/meat/manage/order/transBill?order_id=10006377&access_token=d73289c0e0d24dae829a15fa1b79ce75&type=1' // 调取接口返回文件流
    // this.formUrl = `${serverUrl}?file=${encodeURIComponent(pdfUrl)}`
    // console.log('this.formUrl',this.formUrl)
  },
  methods: {

    downloaindPdf({ order_id, type }) {
      this.btnLoading= true
     let url =transBilPc
     let data = {
        access_token: this.userInfo.access_token,
        order_id,
        type: 1,
      };


      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data:param,
        url,
      })
        .then((res) => {
          this.btnLoading= false
          console.log(res);
          if (res.data.resultCode == 1) {
           window.open(`${baseUrl}/transbill/order/${res.data.data[0]}`, '_blank')
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch((err) => {
           this.btnLoading= false
          this.$alert(JSON.stringify(err));
        });
    },
    getTime(time) {
      return formateDate(time);
    },
    outboundPrint(row) {
      let that = this;
      let url = getOutBillUrl;
      let { id: oid } = row;
      let data = {
        oid,
      };
      console.log(url);
      console.log(data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (parseInt(res.data.resultCode) === 1) {
            console.log("屠宰场查询本厂的预约单列表:", res);
            console.log("111", res.data.data);
            that.stockOutBillObj = JSON.parse(JSON.stringify(res.data.data));
            let { plist } = res.data.data;
            that.productData = JSON.parse(JSON.stringify(plist));
            console.log(that.stockOutBillObj, that.productData);
            if (window.matchMedia) {
              var mediaQueryList = window.matchMedia("print"); //为印添加事件
              mediaQueryList.addListener(function (mql) {
                if (mql.matches) {
                } else {
                  console.log(999988);
                  that.$router.go(0);
                  //   that.reload();
                }
              });
            }
            setTimeout(() => {
              var headstr = "<html><head><title></title></head><body>";
              var footstr = "</body>";
              var printData = document.getElementById("div_print").innerHTML; // 获得 div 里的所有 html 数据
              console.log(printData);
              var oldstr = document.body.innerHTML;
              document.body.innerHTML = headstr + printData + footstr;
              window.print();
              document.body.innerHTML = oldstr;
            }, 1000);
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err));
        });
    },
    renderItemTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },
    buttonClick(value, orderItem) {
      this.currentOrderInfo = orderItem;
      this.$nextTick(() => {
        
        this[value](orderItem);
      });
      console.log(222);
    },
    handlePaneClick(tab, event) {
      this.index = tab.index - 0;
      this.initOrderList(this.formInlineStatus.status);
    },
    haveGetGoods() {
      this.$confirm("确认收货,收货后支付款将打入商家账户", { showClose: false })
        .then(() => {
          this.ensureGetGoods();
        })
        .catch(() => {});
    },
    ensureGetGoods() {
      let url = confirmReceiveOrderUrl;

      // access_token,
      // 										price,
      // 										weight:totalWeight,
      // 										orderId:id,
      // 										store_id:storeId

      let { id } = this.currentOrderInfo;
      let data = {
        orderId: id,
        access_token: this.userInfo.access_token,
      };
      console.log("data", data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.initOrderList(this.formInlineStatus.status);
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err));
        });
    },
    toPay() {
      let {
        id,
        order_id,
        totalMoney,
        prepayment,
        type,
        fm_status,
        pay_flag,
        store_name,
        store_id,
      } = this.currentOrderInfo;
      console.log("this.currentOrderInfo");
      console.log(this.currentOrderInfo);
      this.$router.push({
        name: "payPage",
        query: {
          id,
          order_id,
          totalMoney,
          prepayment,
          type,
          fm_status,
          pay_flag,
          store_name,
          store_id,
        },
      });
    },
    formatteStatus(status, fm_status) {
      let text = "";
      switch (status) {
        case 1:
          text = "等待买家付款";
          break;
        case 2:
          text = "等待卖家发货";
          break;
        case 3:
          text = "卖家已发货";
          break;
        case 4:
          text = "等待买家评价";
          break;
        case 5:
          text = "订单已完成";
          break;
        case 6:
          text = "订单已取消";
          break;
        case 7:
          text = "订单已过期";
          break;
        case 8:
          text = "订单已删除";
          break;
        case 9:
          text = "已申请退款";
          break;
        case 10:
          text = "退款成功";
          break;
        case 11:
          text = "退款失败";
          break;
        case 12:
          text = "等待商家确认金额";
          break;
        case 13:
          text = "等待补款";
          break;
        case 14:
          text = "商家同意退款";
          break;
        case 15:
          text = "商家拒绝退款";
          break;
        default:
          break;
      }
      if (fm_status == 1 && status == 1) {
        text = "等待支付定金";
      }
      return text;
    },

    beforeAvatarUpload(file) {
      const isRightType =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isRightType) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isRightType && isLt2M;
    },
    bitchDelete() {
      if (this.tableSelectedItem.length == 0) {
        this.$alert("没有被选中的选项", "提示", {
          confirmButtonText: "确定",
          // type: "warning",
          center: true,
        });
      } else {
        this.$confirm("删除所有选中行, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          // type: "warning"
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    refreshList() {
      //获取当前的状态，重新请求数据
      this.initOrderList(
        this.formInlineStatus.status,
        this.pagination.currentPage - 1,
        this.pagination.size,
        this.formInlineStatus.type
      );
    },
    changeFun(val) {
      this.tableSelectedItem = val;
    },
    renderContent() {},
    processData({ p_list = [], o_list = [], m_list = [] }) {
      return o_list.map((order) => ({
        ...order,
        products: p_list
          .filter((product) => product.orderId === order.id)
          .map((product) => ({
            ...product,
            items: m_list.filter((item) => item.opId === product.id),
          })),
      }));
    },
    initOrderList(status = 0, pageIndex = 0, pageSize = 15, type = 1) {
      //store_id:userInfo.storeId, o_status,pageSize

      // case 0:return ''
      // case 1: return '1'
      // case 2: return '2'
      // case 3: return '3'
      // case 4: return '4'
      // case 5: return '12,13'
      // case 6: return '9,10,11,14,15'

      let that = this;
      this.loading = true;
      let url = queryOrderListUrl;
      // let url = queryManagerOrderListUrl;
      console.log("this.userInfo");
      console.log(this.userInfo);
      let data = {
        access_token: that.userInfo.access_token,
        store_id: this.userInfo.storeId,
        o_status: this.getOrderStatus,
        pageNum: pageIndex,
        pageSize: pageSize,
        type: 2,
        _date: new Date().getTime(),
      };

      data.status == 3 ? delete data.status : "";

      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            let data1 = res.data.data;
            data1 = that.processData(data1 || {}).filter((item) => {
              return item.type != 9;
            });
            console.log("res.data", res.data);
            // console.log("res.data.data.o_count", res.data.data.o_count);

            that.DirectionalContractTableData = JSON.parse(
              JSON.stringify(data1)
            );
            console.log(
              "that.DirectionalContractTableData",
              JSON.stringify(that.DirectionalContractTableData)
            );

            that.pagination.count = res.data.data ? res.data.data.o_count : 0;
          } else {
            that.loading = false;
            that.$alert(`${res.data.resultMsg}`).then(() => {});
          }
        })
        .catch((err) => {
          this.$alert(`${err}`);
        });
    },
    formatterStatus(row, column) {
      let msg = "";
      switch (row.status) {
        case 0:
          msg = "申请中";
          break;
        case 1:
          msg = "已通过";
          break;
        case 2:
          msg = "已拒绝";
          break;
        case 3:
          msg = "已封禁";
          break;
      }
      return msg;
    },
    formatterType(row, column) {
      let msg = "";
      switch (row.type) {
        case 1:
          msg = "定向屠宰合同";
          break;
        case 2:
          msg = "外调白条合同";
          break;
      }
      return msg;
    },
    statusChange(e) {
      this.formInlineStatus.status = e;
      this.initOrderList(
        e,
        this.pagination.currentPage - 1,
        this.pagination.size,
        this.formInlineStatus.type
      );
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.initOrderList(
        this.formInlineStatus.status,
        this.pagination.currentPage - 1,
        this.pagination.size,
        this.formInlineStatus.type
      );
    },
    handleCurrentChange(val) {
      this.initOrderList(
        this.formInlineStatus.status,
        this.pagination.currentPage - 1,
        this.pagination.size,
        this.formInlineStatus.type
      );
    },
    checkImgAtTable(item) {
      console.log(item);
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: item.p_id,
          type: -1,
        },
      });
    },
    checkFormHtImg(e) {
      this.ImgAtForm.src = e.target.dataset["src"];
      this.ImgAtForm.dialogShow = true;
    },

    headerStyle() {
      return {};
    },
    typeChange(e) {
      this.formInlineStatus.type = e;
      this.formInlineStatus.status = 3;
      this.initOrderList(
        3,
        this.pagination.currentPage - 1,
        this.pagination.size,
        e
      );
    },
  },
  watch: {
    $route() {
      this.initOrderList(this.formInlineStatus.status);
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and(min-width:320px) and(max-width:1200px) {
  .table_container {
    padding: 0 10px 20px !important;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.buttonText {
  display: inline-block;
  margin: 2px 0;
}

.table_container {
  padding: 0 150px 20px;
  min-width: 1000px;
  margin-top: 10px;
}

.table_container_header {
  height: 50px;
}

.dialog-footer {
  margin-top: 100px;
}
.orderTitle {
  display: flex;
  flex-direction: row;
  align-content: center;
  padding: 10px;
  justify-content: space-around;
}
.orderTitleText {
  text-align: center;
  flex: 1;
  font-size: 14px;
  color: #333;
}
.order {
  margin-top: 10px;
}
.orderListTitle {
}
.orderTitleText.first {
  flex: 4;
}
.listItem {
  text-align: left;
}
.htzp {
  width: 100px;
  height: 100px;
  margin-right: 5px;
}
.orderDescBox {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
}
.orderDescBoxLeft {
}
.orderTabsTitleText {
  font-size: 16px;
  font-weight: 700;
}
.gooodsListTilecreatTime {
  font-weight: 700;
  margin-right: 20px;
  min-height: 400px;
}
.orderDescBoxRight {
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  text-align: left;
  margin-left: 5px;
}
.htzp-container {
  height: 100px;
}
.bigHtImg {
  width: 100%;
}
.bigHtImgAtForm {
  width: 100%;
}
.goodsTitle {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #eff7ff;
}
.goodsItemImg {
  width: 100px;
  height: 100px;
}
.goodsItemImg:hover {
  cursor: pointer;
}
.orderItem {
  margin-bottom: 50px;
  border: 1px solid #e8e8e8;
}
.productsList .orderTitleText {
  background-color: #fff;
}
.buttonBox {
  font-size: 12px;
  color: #409eff;
}

.orderTitleBgc {
  background-color: #f1f1f1;
}
.flexVCenterHright {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  padding-right: 10px;
}
.flexVCenter {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.productItemTotalMoney {
  font-weight: 700;
  color: #ff3e1d;
}
.productItemPrice {
  color: #333;
  font-size: 14px;
}
.el-icon-chat-dot-square:hover {
  cursor: pointer;
  font-size: 14px;
}
.paginationBox {
  padding-top: 10px;
}
.empty-list {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  height: 100px;
  padding-bottom: 200px;
}
.empty-list-text,
.el-icon-tickets {
  color: #afafaf;
  font-size: 20px;
}
.orderDescBoxRightPname {
}
.gray {
  color: #666;
}
.gooodsList {
}
.ensureGetGoods {
  display: inline-block;
  padding: 6px 15px;
  background-color: #f40;
  color: #fff;
  border-radius: 3px;
}
.ensureGetGoods:hover {
  color: #fff !important;
}
//打印css start
#div_print {
  color: #43499f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  //   display: none;
}
.printHead {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: sapce-around;
  flex-wrap: wrap;
  font-size: 20px;
  margin: 10px auto;
}
.printHead div {
  width: 33%;
}
.printMoney {
  width: 80%;
  font-size: 23px;
  margin: 5px auto;
}
.printMsg {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 18px;
  margin: 5px auto;
}
.printRemark {
  width: 80%;
  font-size: 20px;
  margin: 0 auto;
}
.table {
  border: 1px solid #43499f;
  text-align: center;
  margin: 5px auto;
}
td {
  border: 1px solid #43499f;
}
td {
  border: 1px solid #43499f;
}
.printTitle {
  width: 100%;
  text-align: center;
}
.getPdfBtn {
  display: inline-block;
  padding: 6px 15px;
  background-color: #f70;
  color: #fff;
  border-radius: 3px;
}
.getPdfBtn:hover {
  color: #fff !important;
}
//打印css end
</style>



// WEBPACK FOOTER //
// src/components/MyOrder/MyOrder.vue